
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'

// module components
import CallsFilters from '@/modules/CallsModule/components/CallsFilters/index.vue'

// types
import { CallT, GetCallsParamsT } from '@/core/types/calls.types'

// realisations
import { couriers } from '@/core/realisations/couriers.realisation'

// constants
import { CallsColumns } from '@/core/constants/columns/Calls.columns'

// classes
import { DataState } from '@/core/classes/DataState.class'

export default defineComponent({
    components: {
        PageTitle,
        FailedFetch,
        TheTable,
        TableScrollWrapper,
        CallsFilters,
    },
    setup() {
        const data_state = reactive({
            calls: new DataState<CallT>({}),
        })

        const filters_state = reactive({
            courierName: null as string | null,
            search: null as string | null,
            type: null as number | null,
            phone: null as string | null,
            createdAtFrom: null as string | null,
            createdAtTo: null as string | null,
            cityId: null as number | null,
            clientName: null as string | null,
            //
            limit: 50,
        })

        const loadCalls = async (page: number) => {
            data_state.calls.pagination.current_page = page

            try {
                data_state.calls.is_loading = true

                const params = {
                    page,
                    ...filters_state,
                }
                const response = await couriers.getCalls(params)

                data_state.calls.list = response.data
                data_state.calls.pagination.total_pages = response.meta.last_page
                data_state.calls.pagination.total_items = response.meta.total

                data_state.calls.is_failed = false
                data_state.calls.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.calls.failure.catchError(error)

                if (!data_state.calls.failure.error_state.is_cancel) {
                    data_state.calls.is_failed = true
                }
            } finally {
                if (!data_state.calls.failure.error_state.is_cancel) {
                    data_state.calls.is_loading = false
                }
            }
        }

        const onLimitChange = (limit: number) => {
            filters_state.limit = limit
            loadCalls(data_state.calls.pagination.current_page)
        }

        onBeforeMount(() => {
            loadCalls(1)
        })

        const applyFilters = (params: GetCallsParamsT) => {
            filters_state.courierName = params.courierName
            filters_state.search = params.search
            filters_state.type = params.type
            filters_state.phone = params.phone
            filters_state.createdAtFrom = params.createdAtFrom
            filters_state.createdAtTo = params.createdAtTo
            filters_state.cityId = params.cityId
            filters_state.clientName = params.clientName

            loadCalls(1)
        }

        const resetFilters = () => {
            filters_state.courierName = null
            filters_state.search = null
            filters_state.type = null
            filters_state.phone = null
            filters_state.createdAtFrom = null
            filters_state.createdAtTo = null
            filters_state.cityId = null
            filters_state.clientName = null

            loadCalls(1)
        }

        return {
            data_state,
            filters_state,
            loadCalls,
            applyFilters,
            resetFilters,
            onLimitChange,
            //
            CallsColumns,
        }
    },
})
